var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import http, { Q } from "@http";
import { observable, action, runInAction } from "mobx";
var TrainingResourceStore = /** @class */ (function () {
    function TrainingResourceStore() {
        this.trainingResource = [];
    }
    TrainingResourceStore.prototype.getAttachment = function (libraryTypeId) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().getAttachment(libraryTypeId)];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.trainingResource = data || [];
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    TrainingResourceStore.prototype.downloadCheck = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().checkSMSUVideoAndGuideDownloadDisclaimer()];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, new Promise(function (resolve) {
                                runInAction(function () {
                                    _this.checkDownload = data || true;
                                    resolve(_this.checkDownload);
                                });
                            })];
                }
            });
        });
    };
    TrainingResourceStore.prototype.updateSMSUDisclaimer = function () {
        return __awaiter(this, void 0, void 0, function () {
            var promise;
            return __generator(this, function (_a) {
                promise = this.api().UpdateSMSUDisclaimer();
                return [2 /*return*/];
            });
        });
    };
    TrainingResourceStore.prototype.api = function () {
        return {
            getAttachment: function (libraryTypeId) {
                return Q(http.post("/SMSU/GetAttachment", { libraryTypeId: libraryTypeId }));
            },
            checkSMSUVideoAndGuideDownloadDisclaimer: function () {
                return Q(http.post("/api/Disclaimer/CheckSMSUVideoAndGuideDownloadDisclaimer"));
            },
            UpdateSMSUDisclaimer: function () {
                return Q(http.post("/api/Disclaimer/UpdateSMSUVideoAndGuideDownloadDisclaimer"));
            }
        };
    };
    __decorate([
        observable
    ], TrainingResourceStore.prototype, "trainingResource", void 0);
    __decorate([
        action
    ], TrainingResourceStore.prototype, "getAttachment", null);
    return TrainingResourceStore;
}());
export default TrainingResourceStore;
